import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  Paper,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  Person,
  PushPin,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useLoginStyle from "../LoginStyle/LoginStyle";
import { loginApi, loginApiWithoutPassword } from "../../../services/service";
import { toast } from "react-toastify";
import ROUTES_NAME from "../../../constants/RoutesName";
import Loader from "../../../components/Loader";
import socket from "../../../socket/socket";
import { useEffect } from "react";
import { useProfile } from "../../../context/ProfileContext";
import logo from '../../../images/iia.jpeg'

function LoginDefault({ handleLogin }) {
  const classes = useLoginStyle();
  const navigate = useNavigate();
  const [error, setError] = useState("Please Enter Credentials");
  const [formData, setFormData] = useState({
    mobileOrRoll: "",
    password: "",
    // pin: "",
  });
  const { setProfile } = useProfile();
  // function isUrlIncludes(keyword) {
  //   return window.location.href.includes(keyword);
  // }

  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // For pin field, only allow numbers and limit to 4 digits
    if (name === "pin") {
      // Only allow numeric input
      const numericValue = value.replace(/\D/g, "");
      // Limit to 4 digits
      if (numericValue.length <= 4) {
        setFormData({ ...formData, [name]: numericValue });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  function getBaseUrl() {
    const url = new URL(window.location.href);
    return `${url.protocol}//${url.host}`;
  }

  const handleSubmit = async () => {
    const { mobileOrRoll, password, pin } = formData;

    if (!mobileOrRoll) {
      toast.error("Please enter roll number");
      return;
    }
    if (!password) {
      toast.error("Please enter password");
      return;
    }
    if (
      password.length < 8 ||
      !/[A-Z]/.test(password) ||
      !/[a-z]/.test(password) ||
      !/[^A-Za-z0-9\s]/.test(password)
    ) {
      toast.error(
        "Password must be at least 8 characters and include an uppercase letter, a lowercase letter, and a special character",
      );
      return;
    }
    // if (!pin) {
    //   toast.error("Please enter pin");
    //   return;
    // }
    // if (pin.length !== 4) {
    //   toast.error("Exam PIN must be exactly 4 digits");
    //   return;
    // }

    setLoading(true);
    try {
      const result = await loginApiWithoutPassword({
        username: mobileOrRoll,
        password: password,
      });
      setProfile(result?.learner);
      // const result = await loginApi({
      //   username: mobileOrRoll,
      //   password: password,
      //   exam_pin: pin,
      // });

      if (result.success) {
        setLoading(false);

        sessionStorage.setItem(
          "userAuth",
          JSON.stringify({
            username: mobileOrRoll,
            password,
          }),
        );
        toast.success("Login Successful!");
        handleLogin();

        navigate(ROUTES_NAME.DASHBOARD);
        // socket.emit("changeStatus", {
        //   examId: result.examId,
        //   userId: result.userId,
        //   status: "On instructions",
        // });

        // const width = window.screen.availWidth;
        // const height = window.screen.availHeight;
        // window.open(
        //   getBaseUrl(),
        //   "_blank",
        //   `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},top=0,left=0`
        // );

        // setTimeout(() => {
        //   sessionStorage.clear();
        // }, 3000);
      } else {
        setLoading(false);
        setError(result.message || "An error occurred");
        toast.error(result.message || "An error occurred");
      }
    } catch (err) {
      setLoading(false);
      setError(err.message || "An error occurred");
      toast.error(err.message || "An error occurred");
    }
  };

  useEffect(() => {
    socket.connect();
    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <Box className={classes.loginContainer}>
      <Paper elevation={4} className={classes.loginPaper}>
        {/* <Typography variant="body1" className={classes.loginSubtext}>
          {error}
        </Typography> */}
        <Typography variant="body1" className={classes.loginSubtext}>
          {error} 
          {/* <img style={{ width:window.location.href.includes("apexexam")? "50%":"80%" }} src={ window.location.href.includes("apexexam") ? apexLogo : mahaveerLogo} alt="logo" /> */}
         {/*  {logo && (
            <img
              style={{
                width: window.location.href.includes("apexexam")
                  ? "50%"
                  : "80%",
              }}
              src={logo}
              alt="logo"
            />
          )}*/}
        </Typography>
        <Typography variant="h4" className={classes.loginTitle} gutterBottom>
          Login
        </Typography>

        <Box mt={2}>
          <Typography variant="body1" gutterBottom>
            {/* Allen Form Number */}
            Roll Number
          </Typography>
          <TextField
            fullWidth
            name="mobileOrRoll"
            placeholder="Roll Number"
            // placeholder="Allen Form Number"
            value={formData.mobileOrRoll}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Person />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box mt={2}>
          <Typography variant="body1" gutterBottom>
            Password
          </Typography>
          <TextField
            fullWidth
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword} edge="end">
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {/* <Box mt={2}>
          <Typography variant="body1" gutterBottom>
            Exam Pin
          </Typography>
          <TextField
            fullWidth
            type={"password"}
            name="pin"
            placeholder="Exam Pin"
            value={formData.pin}
            onChange={handleChange}
            inputProps={{
              maxLength: 4,
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PushPin />
                </InputAdornment>
              ),
            }}
          />
          {formData.pin.length > 0 && formData.pin.length !== 4 && (
            <div
              style={{
                fontSize: "13px",
                color: "red",
                marginTop: "5px",
                marginLeft: "5px",
                fontFamily: "",
              }}
            >
              <Typography variant="body2" gutterBottom>
                Exam PIN must be exactly 4 digits
              </Typography>
            </div>
          )}
        </Box> */}

        <Box mt={2}>
          <Button
            variant="contained"
            fullWidth
            className={classes.loginButton}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </Paper>
      <Typography className={classes.versionText}>
        Version 5.3.0 | Dated - 01 October 2026
        {/* FINALT */}
      </Typography>
      {loading && <Loader />}
    </Box>
  );
}

export default LoginDefault;